import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=6160ac6e&scoped=true&"
var script = {}
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=6160ac6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160ac6e",
  null
  
)

export default component.exports